import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

import { spacing_0_25, spacing_1_5, spacing_2 } from 'components/corpSite/components/theme/spacing'
import { gray_6 } from 'components/corpSite/components/theme/colors'
import { xsMd } from 'components/corpSite/components/theme/utils/media-query'
import { f_1 } from 'components/corpSite/components/theme/type-scale'

import FlexContainer from 'components/corpSite/components/shared/flex-container'

import CircledIcon from 'components/corpSite/components/shared/circled-icon'

import HouseSitterIcon from 'components/corpSite/imgs/careguide-corp/icons/housesitter.com.svg'
import PetSitterIcon from 'components/corpSite/imgs/careguide-corp/icons/petsitter.com.svg'
import CNIcon from 'components/corpSite/imgs/careguide-corp/icons/canadiannanny.ca.svg'

const makeTestimonialContainer = () =>
  styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    ${() =>
      xsMd(
        css`
           {
            flex-direction: column;
          }
        `
      )};
  `

const makeStyledText = () =>
  styled.div`
    font-size: ${f_1};
    text-align: center;
    width: ${(props) => props.width || '230px'};
    colors: ${gray_6};
    margin-bottom: ${(props) => props.marginBottom || spacing_1_5};
  `

const StyledText = makeStyledText()

const Testimonial = ({ icon, name, location, children }) => (
  <FlexContainer marginBottom={spacing_2} direction='column' alignItems='center'>
    <CircledIcon icon={icon} radius={128} marginBottom={spacing_2} marginRight={'0'} />
    <StyledText width='217px'>{children}</StyledText>
    <StyledText marginBottom={spacing_0_25} width='217px'>
      {name}
    </StyledText>
    <StyledText marginBottom={spacing_0_25} width='217px'>
      {location}
    </StyledText>
  </FlexContainer>
)

Testimonial.propTypes = {
  icon: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
}

const TestimonialContainer = makeTestimonialContainer()

const Testimonials = () => (
  <TestimonialContainer>
    <FlexContainer flexWrap justifyContent='center' alignItems='center'>
      <Testimonial icon={HouseSitterIcon} name='Elliot' location='Chestnut Hill, MA'>
        <span>
          “I received many more responses from <b>qualified people</b> than I had expected and the
          site is easy to navigate.”
        </span>
      </Testimonial>
      <Testimonial icon={PetSitterIcon} name='Robin' location='Prunedale, CA'>
        <span>
          “Really impressed with the timely responses and the invitation to ask any questions I may
          have. <b>I feel supported</b>. Thank you for that!”
        </span>
      </Testimonial>
      <Testimonial icon={CNIcon} name='Mia' location='Toronto, ON'>
        <span>
          “Helped me find a great nanny, whose services I could afford. Also helped me find a great,
          well-paying nanny job later on. Both were <b>found quickly</b>.”
        </span>
      </Testimonial>
    </FlexContainer>
  </TestimonialContainer>
)

export default Testimonials
